import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App"; // Ensure this is the correct path
import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap import
import "./index.css"; // Your global styles if any

const rootElement = document.getElementById("root");

if (!rootElement) {
  console.error("No root element found in index.html. Check your HTML file.");
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
